<div class="container-fluid">
  <div id="header" class="navbar-central">
    <div class="navbar">
      <a href="auth/login"><img src="../../../../../assets/images/base_logo_transparent_background.png" style="width: 150px; height: 23px;"></a>
    </div>

    <div id="infos-right">
      <ul>
        <li><a href="auth/login" class="btn btn-secondary">Entrar</a></li>
        <li><a href="auth/login" class="btn btn-primary">Fale Conosco</a></li>
      </ul>
    </div>
  </div>

  <!-- content -->
  <div class="container-fluid page">
    <div class="search-central">
      
      <h2>Olá, como podemos ajudar você?</h2>
      
      <div class="search-bar"  [formGroup]="searchForm" >
        <input class="form-control"  formControlName="searchtext"  type="text" placeholder="Digite sua dúvida ou uma palavra-chave" (keyup.enter)="send()">
      </div> 



      <div class="central-logos">
        <div *ngFor="let item of items" >
          <a  [href]="'kb/' + item.id + '/articles'" class="card">
            <!-- <img src="../../../../../assets/images/btn-central01.png" alt="{{item.name}}"> -->
            <span>{{item.name}}</span>
          </a>
        </div>
        
      </div>

    </div>
  </div>
  <!-- / content -->
</div>


<!-- <div class="bg-content-central">

  <div class="container">
    <h3>Artigos mais populares</h3>
    <a href="#" class="btn btn-inline">04- Tabela CFOP - SEFAZ</a>
    <a href="#" class="btn btn-inline">Que bom te ver na nossa base de conhecimento do NFeMail!</a>
    <a href="#" class="btn btn-inline">01- Como emitir nota de Devolução (Vídeo) - NFemail</a>


    <br><br><br>


    <h3>Artigos mais populares</h3>
    <a href="#" class="btn btn-inline">652 - Rejeição: Informado indicador de desoneração inválido para a ZFM [nItem:999]</a>
    <a href="#" class="btn btn-inline">14 - Como emitir NFS-e Nacional - NFemail</a>
    <a href="#" class="btn btn-inline">Como configuro o tempo médio de preparo e valor mínimo do pedido? - KDoQ</a>
  </div>

</div> -->


<footer class="central">
  <h3>Atendimento comercial e suporte</h3>
  <!-- <a href="#" class="btn btn-inline">contato@nfemail.com.br</a> -->
</footer>

